import React from "react";

const NeedHelp = () => {
  return (
    <div className="needHelpContainer">
      <div className="needHelpWrapper">
        <div className="iconItems">
          <div className="iconsWrap">
          <svg
              id="Layer_11"
              data-name="Layer 2"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18.96 7.73"
              width="30"
              height="30"
            >
              <defs>
                <style>
                  {`

      #Layer_11 .cls-1 {
        fill: #01e5c8;
      }

      #Layer_11 .cls-2 {
        fill: #fff;
      }

      #Layer_11 .cls-3 {
        fill: #d6d6d6;
        stroke: #000;
        strokeMiterlimit: 10;
        strokeWidth: .22px;
      }
    `}
                </style>
              </defs>
              <g id="Layer_1-2" data-name="Layer 1">
                <path d="m14.82,5.44c-.21-.33-.41-.67-.61-1L11.69.18c0-.05-.06-.08-.09-.14l-.32.53c-.81,1.36-1.6,2.72-2.43,4.06-.53.92-1.5,1.49-2.56,1.51h-2.36v-3.61h.73v2.9h1.6c1.3,0,2.37-1.04,2.37-2.35,0-1.19-.87-2.2-2.05-2.35-.11,0-.23,0-.34,0H.7v5.43h-.7V0h6.24c1.43-.01,2.67.96,3,2.35,0,.03,0,.07,0,.1l.52-.84c.29-.5.6-1,.9-1.48.03-.07.1-.12.18-.11h1.43c.07-.03.16,0,.2.07l2.75,4.47c.03.05.03.12,0,.17-.13.23-.27.45-.4.67h0v.04Z" />
                <path
                  className="cls-1"
                  d="m3.61,2.51v.73H.96V.99h5.36c1.15,0,2.08.95,2.08,2.1,0,.93-.62,1.74-1.52,2-.17.05-.34.08-.51.08h-1.41v-2.65h.73v1.92c.36.04.73,0,1.08-.09.7-.28,1.04-1.08.76-1.78-.2-.49-.66-.83-1.19-.86H1.68v.79h1.93Z"
                />
                <path
                  className="cls-1"
                  d="m14.3,5.15h-3.73v-.7h2.42c-.48-.79-.94-1.55-1.4-2.33-.26.47-.52.91-.78,1.35-.48.85-1,1.7-1.45,2.56-.04.08-.13.14-.22.13h-.85L11.59.67c.9,1.5,1.8,2.98,2.71,4.48Z"
                />
                <path d="m3.61,3.56v.72h-1.95v1.86h-.71v-2.58h2.66Z" />
                <path d="m14.77,5.43c-.12.21-.26.42-.37.63-.03.06-.09.1-.16.09h-3.7v-.72h4.23Z" />
                <circle className="cls-3" cx="15.67" cy="4.85" r="2.77" />
                <path
                  className="cls-2"
                  d="m15.35,6.53l-1.8-1.74c-.18-.13-.21-.38-.08-.56s.38-.21.56-.08c.03.02.06.05.08.08l1.28,1.25,2.89-2.39c.14-.16.39-.17.55-.03.16.14.17.39.03.55-.02.03-.05.05-.08.07l-3.43,2.85Z"
                />
              </g>
            </svg>
          </div>
          <p>US FDA Approved</p>
        </div>
        <div className="iconItems">
          <div className="iconsWrap">
          <svg
  id="Layer_30"
  className="new-trial-icons-svg"
  data-name="Layer 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  width="30"
  height="30"
>
  <defs>
    <style>
        {`
    #Layer_30 .cls-9 {
        fill: #c8fff7;
      }
      #Layer_30 .cls-10 {
        fill: none;
        stroke: #1be1c8;
        strokeWidth: 0.5px;
      }
      #Layer_30 .cls-10,
      #Layer_30 .cls-11 {
        strokeMiterlimit: 10;
      }
      #Layer_30 .cls-11 {
        fill: #f2f2f2;
        stroke: #000;
        strokeWidth: 0.18px;
      }
      #Layer_30 .cls-12 {
        fill: #111;
      }
      #Layer_30 .cls-13 {
        fill: #1be1c8;
      }
      #Layer_30 .cls-14 {
        fill: #fff;
      }
      `}
    </style>
  </defs>
  <path
    className="cls-9"
    d="M2.77,18.75l1-1.19A69.18,69.18,0,0,1,11,16.06c1.33,0,8.67.6,9.92,1.79s-1.41,1.57-1.41,1.57L3,19.12S2.57,19.63,2.77,18.75Z"
  ></path>
  <path
    className="cls-10"
    d="M3,17.87a22.3,22.3,0,0,1,8-1.81,22.61,22.61,0,0,1,10,2"
  ></path>
  <path
    d="M7.26,11l3.11,3.16,1.55-1.55-.12-.12c-.53-.54-1.07-1.08-1.61-1.61a.69.69,0,0,1-.11-.13.24.24,0,0,1,0-.33.24.24,0,0,1,.34,0c.06,0,.11.11.17.17l1.67,1.67,1.34-1.36h-.77a.26.26,0,0,1-.25-.27.25.25,0,0,1,.25-.25h1.4c.24,0,.34.1.34.33V12c0,.19-.11.31-.26.31s-.26-.12-.26-.31,0-.49,0-.7l-1.31,1.31,1.48,1.5,3.27-3.27h-.64a.66.66,0,0,1-.2,0,.24.24,0,0,1-.21-.27.23.23,0,0,1,.22-.24h1.44c.27,0,.38.11.38.39V12c0,.23-.1.37-.27.36S18,12.22,18,12v-.74l-.15.14-3.26,3.26c-.23.23-.34.23-.57,0L12.33,13l-.13.14-1.53,1.52c-.22.22-.35.22-.58,0C9,13.52,7.82,12.39,6.68,11.25a.3.3,0,0,0-.28-.11,3.64,3.64,0,1,1,1-.18ZM5.89,7.3h0V6.7c0-.2-.1-.32-.26-.32s-.26.12-.26.33V7.77c0,.27-.14.44-.37.45S4.62,8,4.61,7.77s0-.73,0-1.09a.27.27,0,0,0-.26-.3.26.26,0,0,0-.26.28c0,.41,0,.82,0,1.23A.89.89,0,0,0,5,8.74a.9.9,0,0,0,.88-.88Zm1.62.42c-.16-.41-.31-.78-.45-1.15a.26.26,0,0,0-.32-.18.27.27,0,0,0-.17.36C6.8,7.36,7,8,7.28,8.56a.28.28,0,0,0,.23.15.25.25,0,0,0,.22-.14C8,8,8.22,7.34,8.45,6.72a.26.26,0,0,0-.16-.33c-.15,0-.27,0-.34.2C7.8,7,7.66,7.32,7.51,7.72Z"
  ></path>
  <circle className="cls-11" cx="6.28" cy="7.47" r="3.68"></circle>
  <path
    className="cls-12"
    d="M5.82,7.56c0,.22,0,.44,0,.66a1,1,0,0,1-2.09,0c0-.47,0-1,0-1.43A.3.3,0,0,1,4,6.49a.33.33,0,0,1,.31.35V8.11c0,.32.18.53.45.52s.42-.2.43-.52V6.87c0-.24.12-.39.31-.38s.29.14.3.37v.7Z"
  ></path>
  <path
    className="cls-12"
    d="M7.71,8.06c.19-.47.35-.9.52-1.32.08-.21.23-.29.4-.23a.28.28,0,0,1,.18.38C8.54,7.61,8.27,8.33,8,9a.33.33,0,0,1-.26.18A.39.39,0,0,1,7.44,9c-.28-.7-.55-1.41-.82-2.12a.32.32,0,0,1,.2-.42c.15,0,.29,0,.37.22C7.36,7.15,7.53,7.58,7.71,8.06Z"
  ></path>
  <path
    className="cls-13"
    d="M21.23,20.74a.43.43,0,0,1-.43.22H3.19a.55.55,0,0,1-.18,0,.29.29,0,0,1-.24-.3A.3.3,0,0,1,3,20.35a.66.66,0,0,1,.2,0H20.78a.46.46,0,0,1,.45.22Z"
  ></path>
  <path
    className="cls-13"
    d="M21.23,19.53a.47.47,0,0,1-.44.19H3a.28.28,0,0,1-.25-.29.29.29,0,0,1,.23-.3H20.75a.49.49,0,0,1,.48.2Z"
  ></path>
  <path className="cls-14" d="M4.8,18.67a13.34,13.34,0,0,1,6.37-1.14"></path>
</svg>

          </div>
          <p>UV Protection</p>
        </div>
        <div className="iconItems">
          <div className="iconsWrap">
          <svg
  id="Layer_20"
  className="new-trial-icons-svg"
  data-name="Layer 20"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  width="30"
  height="30"
>
  <defs>
    <style>
        {`
      #Layer_20 .cls-1 {
        fill: #43ffe4;
        opacity: 0.29;
      }
      #Layer_20 .cls-2 {
        fill: #1be1c8;
      }
      #Layer_20 .cls-3 {
        fill: #c8fff7;
      }
      #Layer_20 .cls-4 {
        fill: none;
        stroke: #000;
        strokeMiterlimit: 10;
        strokeWidth: 0.48px;
      }
    `}
    </style>
  </defs>
  <path
    className="cls-1"
    d="M14.52,7.94v.45a1.32,1.32,0,0,1-2.6-.05,1.27,1.27,0,0,1,.2-1c.29-.4.6-.79.92-1.19l.1-.1h.1l.13.12.84,1.1a1.41,1.41,0,0,1,.26.52,3,3,0,0,0,0,.66Z"
  ></path>
  <path
    className="cls-2"
    d="M14.43,7.76h.05a1.41,1.41,0,0,0-.26-.52l-.84-1.1L13.25,6h-.1l-.1.09-.93,1.19a1.38,1.38,0,0,0-.24,1.06A1.32,1.32,0,0,0,13.4,9.43a1.33,1.33,0,0,0,1.08-1c.07-.08,0-.69,0-.71"
  ></path>
  <path
    className="cls-3"
    d="M13.23,8.84a.17.17,0,0,1-.18-.14.19.19,0,0,1,.15-.2c.3-.05.37-.13.42-.42a.18.18,0,0,1,.17-.18.18.18,0,0,1,.18.18.75.75,0,0,1-.73.76Z"
  ></path>
  <path
    className="cls-1"
    d="M7.05,11.67v.58a1.7,1.7,0,0,1-3.33-.08A1.6,1.6,0,0,1,4,10.83c.38-.51.77-1,1.18-1.53l.13-.12h.13a1.29,1.29,0,0,1,.17.16l1.08,1.4a2,2,0,0,1,.33.67,4,4,0,0,0,0,.84Z"
  ></path>
  <path
    className="cls-2"
    d="M6.93,11.43H7a1.64,1.64,0,0,0-.33-.66c-.35-.48-.71-.95-1.07-1.41a1.29,1.29,0,0,0-.17-.16H5.29l-.13.12L4,10.84a1.66,1.66,0,0,0-.31,1.35A1.69,1.69,0,0,0,7,12.26a1.42,1.42,0,0,0,0-.92"
  ></path>
  <path
    className="cls-3"
    d="M5.4,12.83a.24.24,0,0,1-.24-.19.23.23,0,0,1,.2-.25c.38-.07.47-.18.53-.55a.23.23,0,0,1,.23-.22.22.22,0,0,1,.22.22,1,1,0,0,1-.93,1Z"
  ></path>
  <path
    className="cls-1"
    d="M10.27,5.29V6a2,2,0,0,1-4-.08,2,2,0,0,1,.3-1.63C7,3.67,7.49,3.05,8,2.43a1.07,1.07,0,0,1,.16-.14H8.3l.2.18L9.8,4.18a2.08,2.08,0,0,1,.4.8,5,5,0,0,0,.06,1Z"
  ></path>
  <path
    className="cls-2"
    d="M10.14,5l.07,0a2.23,2.23,0,0,0-.4-.8c-.43-.57-.86-1.14-1.3-1.7a1.8,1.8,0,0,0-.2-.19H8.15A1.14,1.14,0,0,0,8,2.45L6.56,4.29a2,2,0,0,0-.37,1.63,2,2,0,0,0,4,.09,1.79,1.79,0,0,0-.05-1.11"
  ></path>
  <path
    className="cls-3"
    d="M8.62,6.85a.22.22,0,0,1-.23-.18.23.23,0,0,1,.2-.25c.37-.07.47-.18.53-.55a.22.22,0,0,1,.22-.22.22.22,0,0,1,.23.22,1,1,0,0,1-.94,1Z"
  ></path>
  <path
    className="cls-3"
    d="M19.55,11.43a8,8,0,0,1-2.36,2.12,21.79,21.79,0,0,1-3.93,2.69,34,34,0,0,1-4.34,2.45A2.92,2.92,0,0,1,7,19.07a6.45,6.45,0,0,1-.92.22c-.08.12-.15.24-.24.36a2.87,2.87,0,0,1,.39.2A9.41,9.41,0,0,0,18,18.14a9.25,9.25,0,0,0,2.51-6.83,2.81,2.81,0,0,1,0-.58h0s-.11-.5-.11-.52C20.14,10.48,19.92,11.19,19.55,11.43Z"
  ></path>
  <path
    className="cls-2"
    d="M17.66,10A54.72,54.72,0,0,0,7,16a5,5,0,0,1-.67.38,5.91,5.91,0,0,1-1.44,2,6.18,6.18,0,0,1,.43.9,6.79,6.79,0,0,1,1.22-.14c2,0,4.67-2,6.33-2.85a32,32,0,0,0,5.32-3.69q.68-.6,1.41-1.17c.12-.28.22-.57.32-.86a5.89,5.89,0,0,1-.24-.58v0a1.09,1.09,0,0,1-.08-.15l-.34,0A12.43,12.43,0,0,0,17.66,10Z"
  ></path>
  <path
    className="cls-4"
    d="M19.9,9.85a3.16,3.16,0,0,0-.87,0,10.15,10.15,0,0,0-2.52.75A37.23,37.23,0,0,0,11.75,13a35.66,35.66,0,0,0-4.5,3.14,9.38,9.38,0,0,0-1.69,1.7,2.34,2.34,0,0,0-.45.89.69.69,0,0,0,.41.77c.23.11.45.23.67.35A9.43,9.43,0,0,0,18,18.12a9.26,9.26,0,0,0,2.5-6.82,2.81,2.81,0,0,1,0-.58.68.68,0,0,0-.58-.86Zm.13.61a7,7,0,0,1-.72,1,17.93,17.93,0,0,1-3.19,2.78,36.24,36.24,0,0,1-4.36,2.69A21.9,21.9,0,0,1,6.47,19a7,7,0,0,1-.92.13,1.14,1.14,0,0,1-.41,0c-.27-.05-.37-.19-.26-.43a5.53,5.53,0,0,1,.73-1.1,16.34,16.34,0,0,1,3-2.69c.89-.63,1.78-1.23,2.69-1.84a39.36,39.36,0,0,1,4.54-2.29,13.74,13.74,0,0,1,3.08-.95,3.3,3.3,0,0,1,.7-.05c.16,0,.42.06.47.17a.63.63,0,0,1-.08.51Z"
  ></path>
  <path className="cls-2" d="M15.33,18.3c1.49-1,3-2.15,3.15-3.68"></path>
</svg>
          </div>
          <p>High Water Content</p>
        </div>
        <div className="iconItems">
          <div className="iconsWrap">
            <svg
              id="Layer_10"
              data-name="Layer 2"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18.83 14.95"
              width="30"
              height="30"
            >
              <defs>
                <style>
                  {`

      #Layer_10 .cls-1 {
        strokeWidth: .28px;
      }

      #Layer_10 .cls-1, #Layer_10 .cls-2, #Layer_10 .cls-3 {
        stroke-miterlimit: 10;
      }

      #Layer_10 .cls-1, #Layer_10 .cls-3 {
        stroke: #000;
      }

      #Layer_10 .cls-4 {
        fill: #d6d6d6;
      }

      #Layer_10 .cls-2 {
        fill: #01e5c8;
        stroke: #1be1c8;
        strokeWidth: .5px;
      }

      #Layer_10 .cls-3 {
        fill: #f2f2f2;
        strokeWidth: .18px;
      }
    `}
                </style>
              </defs>
              <g id="Layer_1-2" data-name="Layer 1">
                <path
                  className="cls-3"
                  d="m2.14,12.25h.3c.3,0,.6.1.9.2.7.3,1.3.7,1.9,1.2,1.1.9,2.4,1.3,3.8,1.2.6,0,1.1-.1,1.7-.2l7.3-1c.4,0,.7-.3.7-.7h0c0-.4-.3-.7-.7-.7h-5.3c-.1,0-.3.1-.3.2h0c-.1.4-.5.8-1,.8s-1-.3-1.3-.7c-.2-.2-.3-.5-.6-.8-.2-.2-.2-.4,0-.6.2-.1.3,0,.5.2s.3.5.5.7c.5.5.8.5.6.4.2.1.9,0,1-.1.1-.2.1-.4,0-.6-.3-.4-1-1.1-1.2-1.5-.5-.9-1.4-1.6-2.4-1.9-.6-.1-1.2-.4-1.9-.5l-.2-.1c-1.3-.2-2.7-.4-4-.5-.2.1-.3,3.4-.3,5Z"
                />
                <path
                  className="cls-2"
                  d="m12.14,1.95h-3.5c-.1,0-.2,0-.2-.1s0-.2.1-.2h3.5v-.1c-.1-.2-.3-.4-.5-.6-.3-.2-.6-.4-1-.4h-1.9q-.1,0-.2-.1c0-.1,0-.2.1-.2h4.6c.1,0,.1.1.1.2s-.1.1-.1.1h-1.8.1c.3.2.6.5.8.9,0,0,.1.1.1.2h.8c.1,0,.2.1.2.2v.1c0,.1-.1.1-.2.1h-.6v.1c0,.4-.1.7-.3,1-.2.4-.6.7-1.1.9-.3.1-.7.2-1,.2h-1.2l.1.1.8.8.5.4.5.5.5.6.7.7.3.3c.1.1.1.2,0,.2s-.2.1-.2,0h0l-.9-.9-1.1-1.2-1.5-1.5-.1-.1c-.1,0-.1-.1-.1-.2s.1-.1.2-.1h1.5c.4,0,.9-.1,1.3-.3s.6-.6.8-1c-.1-.2-.1-.4-.1-.6Z"
                />
                <rect
                  className="cls-1"
                  x=".14"
                  y="7.35"
                  width="1.3"
                  height="4.9"
                />
                <path
                  className="cls-4"
                  d="m2.24,8.35c1.3.1,2.6.4,3.9.6.5.2,4.2,1.1,4.2,1.1,0,0-.4-1.4-4.3-2.2-2-.3-3.7-.4-3.7-.4l-.1.9Z"
                />
              </g>
            </svg>
          </div>
          <p>Affordable & Easy</p>
        </div>
      </div>
      <a
        href="https://aqualens.in/pages/support-landing"
        className="needHelpCTA"
      >
        <button>Need Help?</button>
      </a>
    </div>
  );
};

export default NeedHelp;
